/**
 * SPDX-License-Identifier: MPL-2.0
 * Copyright 2021-2023 (c) Christian von Arnim, ISW University of Stuttgart (for umati and VDW e.V.)
 */

import { createAction } from '@reduxjs/toolkit';

export const ErrorActionTypes = {
  Error: 'Error_Error',
};

export const ErrorAction = {
  Error: createAction<string>(ErrorActionTypes.Error),
};

export default class ErrorActions {
  static Error(msg: string) {
    return ErrorAction.Error(msg);
  }
}
